import {
  BibliographyRealReserveSetBibliography,
  BibliographyRealReserveSetBibliographyFromJSON,
  exists
} from '@/api'

export interface BibliographyRealReserveSet {
  id: number
  name: string
  nameKana: string
  revision: number
  bibliographies: BibliographyRealReserveSetBibliography[]
}

export function BibliographyRealReserveSetFromJSON(
  json: any
): BibliographyRealReserveSet {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographies: exists(json, 'bibliographies')
      ? json.bibliographies.map(BibliographyRealReserveSetBibliographyFromJSON)
      : []
  }
}
